/*
 * r16p (2026-10-24), DESIGN D:/NecroWork/dm-chats-evidence/DESIGN.md 6.11 / 7.2: the Unread column of the Slots table and the phone
 * card's Unread figure - a twin of lib/storyColumns.js.
 *
 * Source: the rows of GET /uiapi/slots (r16p server, switch necro.server.chats.unreadColumn):
 *   unread_dms          the count (Step A: V1's igacc_stats.unreadDmsCount, the Instagram badge at the last session; Step B, for a
 *                       slot synced within 48 h: threads with unread from the inbox read). -1 = the worker could not read it.
 *   unread_dms_source   'inbox' | 'badge' (optional; the tooltip says which)
 *   unread_dms_at       optional, when the inbox was read / the badge seen (epoch ms or ISO)
 * A row without the field shows a dash, never 0: a server before r16p has not recorded "no unread messages". -1 shows "?".
 * The column is drawn only when at least one row carries the field (anyUnreadData), like the story columns.
 */

const num = (v) => {
  if (v === null || v === undefined || v === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

const toMs = (v) => {
  if (v === null || v === undefined || v === '') return null;
  if (typeof v === 'number') return Number.isFinite(v) ? v : null;
  const s = String(v).trim();
  if (/^\d{10,}$/.test(s)) return Number(s);
  const t = Date.parse(s);
  return Number.isFinite(t) ? t : null;
};

/** One row -> { count, unknown, source, at } or null when the server did not send the field. */
export function unreadCount(row) {
  if (!row || !Object.prototype.hasOwnProperty.call(row, 'unread_dms')) return null;
  const n = num(row.unread_dms);
  if (n === null) return null;
  const source = row.unread_dms_source === 'inbox' ? 'inbox' : (row.unread_dms_source === 'badge' ? 'badge' : null);
  if (n < 0) return { count: null, unknown: true, source, at: toMs(row.unread_dms_at) };
  return { count: Math.floor(n), unknown: false, source, at: toMs(row.unread_dms_at) };
}

/** What the cell shows: the count, "?" for unknown, "-" when not sent. */
export function unreadText(c) {
  if (!c) return '-';
  if (c.unknown) return '?';
  return String(c.count);
}

const pad2 = (n) => String(n).padStart(2, '0');

/** Tooltip: where the number comes from (design 6.11 Step B: "from the inbox read at HH:MM" or "the Instagram badge"). */
export function unreadTitle(c) {
  if (!c) return 'Unread messages: not reported by this server';
  const when = c.at ? (() => { const d = new Date(c.at); return ` at ${pad2(d.getHours())}:${pad2(d.getMinutes())}`; })() : '';
  if (c.unknown) return 'Unread messages: the worker could not read the Instagram badge at the last session';
  if (c.source === 'inbox') return `Unread conversations, from the inbox read${when}. Click to open the inbox.`;
  if (c.source === 'badge') return `Unread messages: the Instagram badge at the last session${when}. Click to open the inbox.`;
  return 'Unread messages at the last session. Click to open the inbox.';
}

/** true when at least one row carries the field - the column is drawn only then. */
export function anyUnreadData(rows) {
  return Array.isArray(rows) && rows.some((r) => unreadCount(r) !== null);
}

/** Sort value: unknown (-1) sorts with 0's neighbours below every real count; not sent sorts last of all. */
export function unreadSortValue(row) {
  const c = unreadCount(row);
  if (!c) return -2;
  if (c.unknown) return -1;
  return c.count;
}
